import { Tooltip } from "@octopusdeploy/design-system-components";
import { StringHelper } from "@octopusdeploy/design-system-octopus-components";
import WarningIcon from "~/components/WarningIcon";
interface VariableWarningTooltipProps {
    warningMessages?: ReadonlyArray<string>;
    onClick?: () => void;
}
export function VariableWarningTooltip({ warningMessages, onClick }: VariableWarningTooltipProps) {
    if (!warningMessages || warningMessages.length === 0)
        return null;
    return (<div onClick={() => onClick && onClick()}>
            <Tooltip content={buildCompositeWarningMessage(warningMessages)}>
                <WarningIcon />
            </Tooltip>
        </div>);
}
function buildCompositeWarningMessage(warnings: ReadonlyArray<string>) {
    return warnings
        .map((text, index) => {
        if (index === 0) {
            return StringHelper.capitalizeFirstLetter(text);
        }
        return text;
    })
        .join(" and ");
}
